import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 998;

  display: flex;
  flex-direction: column;

  background-color: ${({ theme }) => theme.panel.solid};
`;
